var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.lager.length > 0
        ? [
            _vm.totalQuantity > 0
              ? _vm._l(_vm.lager, function(la) {
                  return _c(
                    "div",
                    [
                      la.warehouseId === 1 && la.quantity > 0
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "mb-2 text-center",
                                class:
                                  "availability-" +
                                  _vm.currentVariation.variation.availability.id
                              },
                              [
                                _vm.lager.length == 2
                                  ? [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(la.quantity) +
                                          " " +
                                          _vm._s(
                                            _vm.currentVariation.unit.names.name
                                          ) +
                                          " -\n            "
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(
                                  "\n             " +
                                    _vm._s(
                                      _vm.currentVariation.variation
                                        .availability.names.name
                                    ) +
                                    "\n          "
                                )
                              ],
                              2
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      la.warehouseId === 119 && la.quantity > 0
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "mb-2 text-center availability-4"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(la.quantity) +
                                    " " +
                                    _vm._s(
                                      _vm.currentVariation.unit.names.name
                                    ) +
                                    " - " +
                                    _vm._s(_vm.propText) +
                                    "\n          "
                                )
                              ]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                })
              : [
                  _c(
                    "div",
                    {
                      staticClass: "mb-2 text-center",
                      class:
                        "availability-" +
                        _vm.currentVariation.variation.availability.id
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$translate(
                              "Woerner::Template.notCurrentlyInWarehouse"
                            )
                          ) +
                          "\n        "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$translate(
                              "Woerner::Template.unknownDeliveryDate"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ]
          ]
        : [
            _c(
              "div",
              {
                staticClass: "mb-2 text-center",
                class:
                  "availability-" +
                  _vm.currentVariation.variation.availability.id
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.currentVariation.variation.availability.names.name
                    ) +
                    "\n      "
                ),
                _vm.zulauf
                  ? [
                      _c("br"),
                      _vm._v("\n        " + _vm._s(_vm.zulauf) + "\n      ")
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }